/* @flow */

export const MAX_VERSION = 4; // Burgundy glider

export const COLONY_ROLE_ADMINISTRATION = 'ADMINISTRATION';
export const COLONY_ROLE_ARBITRATION = 'ARBITRATION';
export const COLONY_ROLE_ARCHITECTURE = 'ARCHITECTURE';
export const COLONY_ROLE_FUNDING = 'FUNDING';
export const COLONY_ROLE_RECOVERY = 'RECOVERY';
export const COLONY_ROLE_ROOT = 'ROOT';

export const COLONY_ROLES = {
  [COLONY_ROLE_RECOVERY]: 0,
  [COLONY_ROLE_ROOT]: 1,
  [COLONY_ROLE_ARBITRATION]: 2,
  [COLONY_ROLE_ARCHITECTURE]: 3,
  // DEPRECATED
  [COLONY_ROLE_FUNDING]: 5,
  [COLONY_ROLE_ADMINISTRATION]: 6,
};

export const DEFAULT_DOMAIN_ID = 1;

export const EMPTY_ADDRESS = '0x0000000000000000000000000000000000000000';
export const ETHER_ADDRESS = EMPTY_ADDRESS;

export const EXPENDITURE_STATUS_ACTIVE = 'ACTIVE';
export const EXPENDITURE_STATUS_CANCELLED = 'CANCELLED';
export const EXPENDITURE_STATUS_FINALIZED = 'FINALIZED';

export const EXPENDITURE_STATUSES = {
  [EXPENDITURE_STATUS_ACTIVE]: 0,
  [EXPENDITURE_STATUS_CANCELLED]: 1,
  [EXPENDITURE_STATUS_FINALIZED]: 2,
};

export const FUNDING_POT_TYPE_DOMAIN = 'DOMAIN';
export const FUNDING_POT_TYPE_PAYMENT = 'PAYMENT';
export const FUNDING_POT_TYPE_TASK = 'TASK';
export const FUNDING_POT_TYPE_EXPENDITURE = 'EXPENDITURE';
export const FUNDING_POT_TYPE_UNASSIGNED = 'UNASSIGNED';

export const FUNDING_POT_TYPES = {
  [FUNDING_POT_TYPE_UNASSIGNED]: 0,
  [FUNDING_POT_TYPE_DOMAIN]: 1,
  [FUNDING_POT_TYPE_TASK]: 2,
  [FUNDING_POT_TYPE_PAYMENT]: 3,
  [FUNDING_POT_TYPE_EXPENDITURE]: 4,
};

export const REWARDS_POT_ID = 0;

export const TASK_RATING_EXCELLENT = 'EXCELLENT';
export const TASK_RATING_NONE = 'NONE';
export const TASK_RATING_SATISFACTORY = 'SATISFACTORY';
export const TASK_RATING_UNSATISFACTORY = 'UNSATISFACTORY';

export const TASK_RATINGS = {
  [TASK_RATING_NONE]: 0,
  [TASK_RATING_UNSATISFACTORY]: 1,
  [TASK_RATING_SATISFACTORY]: 2,
  [TASK_RATING_EXCELLENT]: 3,
};

export const TASK_ROLE_MANAGER = 'MANAGER';
export const TASK_ROLE_EVALUATOR = 'EVALUATOR';
export const TASK_ROLE_WORKER = 'WORKER';

export const TASK_ROLES = {
  [TASK_ROLE_MANAGER]: 0,
  [TASK_ROLE_EVALUATOR]: 1,
  [TASK_ROLE_WORKER]: 2,
};

export const TASK_STATUS_ACTIVE = 'ACTIVE';
export const TASK_STATUS_CANCELLED = 'CANCELLED';
export const TASK_STATUS_FINALIZED = 'FINALIZED';

export const TASK_STATUSES = {
  [TASK_STATUS_ACTIVE]: 0,
  [TASK_STATUS_CANCELLED]: 1,
  [TASK_STATUS_FINALIZED]: 2,
};
